<div class="row col-12 p-0 m-0 main-page-section ">
  <!-- <div class="p-0">
        <app-side-nav [item]="meetingNav"></app-side-nav>
    </div> -->

  <div class="col-12 p-0">
    <!-- <app-header></app-header> -->
    <div class="div-height">
      <div class="details-background">
        <div class="breadcrumbs-section">
          <span class="prev-page pr-1 "><a routerLink="/overview">Home</a></span>
          <span class="separator">&nbsp; > &nbsp;</span>
          <span class="prev-page pr-1 "><a routerLink="/employees/employees-list">Employees</a></span>
          <span class="separator">&nbsp; > &nbsp;</span>
          <span class="curr-page pl-1 breadcrumbs-section-font">Employee Details</span>
        </div>
        <label class="meetings padding-left-employees">Employee Details</label>
        <div class="col-12 row d-flex padding-left-employees">
          <!-- <div class="col-4 flex-column pt-3">
            <div class="d-flex flex-column">
              <span class="name">
                Name
              </span>
              <span class="details">
                {{employeeDetails?.userName}}
              </span>
            </div>

            <div class="d-flex flex-column pt-3">
              <span class="name">
                Email ID
              </span>
              <span class="details">
                {{employeeDetails?.emailId}}
              </span>
            </div>
          </div>
          <div class="col-4 flex-column pt-3">
            <div class="d-flex flex-column">
              <span class="name">
                Activation Date
              </span>
              <span class="details">
                {{employeeDetails?.createdDate| date: 'dd-MM-yy'}}
              </span>
            </div>

            <div class="d-flex flex-column pt-3">
              <span class="name">
                Department
              </span>
              <span class="details">
                {{deptInfo?.data?.department}}
              </span>
            </div>
          </div>
          <div class="col-4">
            <div class="circle">
              <div class="circle-name">{{acronym}}</div>
            </div>
          </div> -->

          <div class="row company-details-section">
            <div class="col-10">
              <div class="row">
                <div class="col-6">
                  <div class="d-flex flex-column">
                    <span class="name">
                      Name
                    </span>
                    <span class="details">
                      {{employeeDetails?.userName}}
                    </span>
                  </div>
                </div>
                <div class="col-6">
                  <div class="d-flex flex-column">
                    <span class="name">
                      Activation Date
                    </span>
                    <span class="details">
                      {{convertDateFormat(employeeDetails?.createdDate| date: 'dd-MM-yy')}}
                      <!-- {{convertDateFormat("23-7-2021")}} -->

                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <div class="d-flex flex-column pt-3">
                    <span class="name">
                      Email ID
                    </span>
                    <span class="details">
                      {{employeeDetails?.emailId}}
                    </span>
                  </div>
                </div>
                <div class="col-6">
                  <div class="d-flex flex-column pt-3">
                    <span class="name">
                      Department
                    </span>
                    <span class="details">
                      {{deptInfo?.data?.department}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-2">
              <div class="circle">
                <div class="circle-name">{{acronym}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="padding-left-employees">
                <div class="line "></div>
            </div> -->
      <div class="d-flex justify-textbox padding-left-employees mt-4">
        <div class="activation-width mt-3">
          <span class="pr-4 activation">Activation </span>
          <label class="switch pl-5">
            <input type="checkbox" [checked]="employeeDetails?.t0200OrgEmployees[0]?.isActive"
              value="employeeDetails?.t0200OrgEmployees[0]?.isActive" [(ngModel)]="activation"
              (ngModelChange)="toggleActivationSelection($event)" (change)="toggleActivationSelection($event)">
            <span class="slider round "></span>
            <ng-template #contentActivation let-modal class="text-center">
              <div class="modal-height">
                <div class="modal-body">
                  <div class="">
                    <div class="text pt-3 pb-3">Are you sure, you want to {{statusText}}</div>
                    <div class="popup-line"></div>
                  </div>
                </div>
                <div class="submit col-12 d-flex justify-content-end ">
                  <div class="pr-3">
                    <button type="button " class="cancel-button pt-3"
                      (click)="modal.close('Save click');onCancel('activation')"><span
                        class="cancel">Cancel</span></button>
                  </div>
                  <button type="button " class="add-button" (click)="revokeAccess('activation')"><span
                      class="add">{{statusText}}</span></button>
                </div>
              </div>
            </ng-template>
          </label>
        </div>
        <!-- <div class="activation-width pl-4 mt-3">
          <span class="pr-4 activation">Privilege </span>
          <label class="switch pl-5">
            <input type="checkbox" [checked]="employeeDetails?.isPriviledge" [value]="employeeDetails?.isPriviledge"
              [(ngModel)]="priviledge" (ngModelChange)="togglePriviledgeSelection($event)"
              (change)="togglePriviledgeSelection($event)">
            <span class="slider round "></span>
            <ng-template #contentPriviledge let-modal class="text-center">
              <div class="modal-height">
                <div class="modal-body">
                  <div class="">
                    <div class="text pt-3 pb-3">Are you sure, you want to revoke privilege</div>
                    <div class="popup-line"></div>
                  </div>
                </div>
                <div class="submit col-12 d-flex justify-content-end ">
                  <div class="pr-3">
                    <button type="button " class="cancel-button pt-3"
                      (click)="modal.close('Save click');onCancel('priviledge')"><span
                        class="cancel">Cancel</span></button>
                  </div>
                  <button type="button " class="add-button"><span class="add"
                      (click)="revokeAccess('privilege')">Revoke</span></button>
                </div>
              </div>
            </ng-template>
          </label>
        </div> -->
      </div>
      <div class="padding-left-employees col-11">
        <div class="line "></div>
      </div>
      <div class="d-flex justify-content-between mt-5 col-11">
        <div class="padding-left-employees access">
          Access
        </div>
        <div class="ml-5">
          <span class="pr-5 select-all">Select All</span>
          <label class="switch pl-5">
            <input type="checkbox" [checked]="selectAll" value="selectAll" [(ngModel)]="selectAll"
              (change)="toggleSelectAllSelection($event)" [disabled]="!activation">
            <span [ngClass]="(activation)?'slider round':'sliderr roundd'"></span>
          </label>
        </div>
      </div>
      <div *ngIf="entryGate.length>0" style="margin-right: 50px;margin-left: 10px;">
        <span class="padding-left-employees entry-gate">Entry Gate</span>
        <div class="padding-left-employees row d-flex mt-3">
          <ng-container class="" *ngFor="let eg of entryGate;let i=index">
            <div class="pr-4 d-flex">
              <div (click)="changeAccess(eg,'entryGate')" [ngClass]="(eg.selected)?'rectangle-select ':'rectangle '">
                <span [ngClass]="(eg.selected)?'text-font':'text-font-deselected'">{{eg.label}}</span>
              </div>
              <span>
                <img *ngIf="eg.selected" class="image-pos-cross justify-content-end" src="/assets/images/cross-mark.png"
                  (click)="changeAccess(eg,'entryGate')" loading="lazy" /></span>
            </div>
          </ng-container>
        </div>

      </div>
      <div class="mt-4" *ngIf="meetingRoomAccess.length>0" style="margin-right: 50px;margin-left: 10px;">
        <span class="padding-left-employees entry-gate ">Meeting Room Access
        </span>
        <div class="padding-left-employees row d-flex mt-3">
          <ng-container class="" *ngFor="let mr of meetingRoomAccess;let i=index">
            <div class="pr-4 d-flex pt-2">
              <div (click)="changeAccess(mr,'meetingRoomAccess')"
                [ngClass]="(mr.selected)?'rectangle-select ':'rectangle '">
                <span [ngClass]="(mr.selected)?'text-font':'text-font-deselected'">{{mr.label}}</span>
              </div>
              <span>
                <img *ngIf="mr.selected" class="image-pos-cross justify-content-end" src="/assets/images/cross-mark.png"
                  (click)="changeAccess(mr,'meetingRoomAccess')" loading="lazy" /></span>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="mt-4" *ngIf="deskAccess.length>0" style="margin-right: 50px;margin-left: 10px;display: none;">
        <span class="padding-left-employees entry-gate ">Desk Access
        </span>
        <div class="padding-left-employees row d-flex mt-3">
          <ng-container class="" *ngFor="let da of deskAccess;let i=index">
            <div class="pr-4 d-flex pt-2">
              <div (click)="changeAccess(da,'deskAccess')" [ngClass]="(da.selected)?'rectangle-select ':'rectangle '">
                <span [ngClass]="(da.selected)?'text-font':'text-font-deselected'">{{da.label}}</span>
              </div>
              <span>
                <img *ngIf="da.selected" class="image-pos-cross justify-content-end" src="/assets/images/cross-mark.png"
                  (click)="changeAccess(da,'deskAccess')" loading="lazy" /></span>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="mt-4" *ngIf="privateSuiteAccess.length>0" style="margin-right: 50px;margin-left: 10px;">
        <span class="padding-left-employees entry-gate ">Private Suite Access
        </span>
        <div class="padding-left-employees row d-flex mt-3">
          <ng-container class="" *ngFor="let ps of privateSuiteAccess;let i=index">
            <div class="pr-4 d-flex pt-2">
              <div (click)="changeAccess(ps,'privateSuiteAccess')"
                [ngClass]="(ps.selected)?'rectangle-select ':'rectangle '">
                <span [ngClass]="(ps.selected)?'text-font':'text-font-deselected'">{{ps.label}}</span>
              </div>
              <span>
                <img *ngIf="ps.selected" class="image-pos-cross justify-content-end" src="/assets/images/cross-mark.png"
                  (click)="changeAccess(ps,'privateSuiteAccess')" loading="lazy" /></span>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="padding-left-employees col-11">
        <div class="line "></div>
      </div>
      <div>
        <label class="padding-left-employees booking-history pt-4">Access Log</label>
        <div class="d-flex row col-12 pt-3 padding-left-employees">
          <div class="form-group capitaland-form-group mr-4">
            <label for="owner-dob" class="form-label  from">From</label>
            <input class="form-control form-control-lg cal-icon cal-style cal-text" (click)="d.toggle()"
              autocomplete="off" [readonly]="true" (keypress)="$event.preventDefault()" id="owner-dob"
              placeholder="dd | mm | yyyy" type="text" name="dp" ngbDatepicker #d="ngbDatepicker"
              [(ngModel)]="accessFromDate">
            <span class="field-error" *ngIf="accessFromDateErr">Please enter valid From date</span>
            <!-- <img src="assets/images/calendar.svg" class="iLife-form-group_custom " (click)="d.toggle()" /> -->
          </div>
          <div class="form-group capitaland-form-group" style="position:relative">
            <label for="owner-dob" class="form-label from">To</label>
            <input class="form-control form-control-lg cal-icon cal-style cal-text" (click)="d1.toggle()"
              autocomplete="off" [readonly]="true" (keypress)="$event.preventDefault()" id="owner-dob"
              placeholder="dd | mm | yyyy" type="text" name="dp" ngbDatepicker #d1="ngbDatepicker"
              [(ngModel)]="accessToDate">
            <span class="field-error" *ngIf="accessToDateErr">Please enter valid To date</span>
            <!-- <img src="assets/images/calendar.svg" class="iLife-form-group_custom" (click)="d1.toggle()" /> -->
          </div>
          <div class="pl-4 pt-3">
            <button class="view" (click)="navigateToReportsWithFilter($event,1)">
              View
            </button>
          </div>
        </div>
      </div>
      <div>
        <label class="padding-left-employees booking-history pt-4">Credit Usage</label>
        <div class="d-flex row col-12 pt-3 padding-left-employees">
          <div class="form-group capitaland-form-group mr-4">
            <label for="owner-dob" class="form-label  from">From</label>
            <input class="form-control form-control-lg cal-icon cal-style cal-text" (click)="d2.toggle()"
              autocomplete="off" [readonly]="true" (keypress)="$event.preventDefault()" id="owner-dob"
              placeholder="dd | mm | yyyy" type="text" name="dp" ngbDatepicker #d2="ngbDatepicker"
              [(ngModel)]="creditFromDate">
            <span class="field-error" *ngIf="creditFromDateErr">Please enter valid From date</span>
            <!-- <img src="assets/images/calendar.svg" class="iLife-form-group_custom " (click)="d.toggle()" /> -->
          </div>
          <div class="form-group capitaland-form-group" style="position:relative">
            <label for="owner-dob" class="form-label from">To</label>
            <input class="form-control form-control-lg cal-icon cal-style cal-text" (click)="d3.toggle()"
              autocomplete="off" [readonly]="true" (keypress)="$event.preventDefault()" id="owner-dob"
              placeholder="dd | mm | yyyy" type="text" name="dp" ngbDatepicker #d3="ngbDatepicker"
              [(ngModel)]="creditToDate">
            <span class="field-error" *ngIf="creditToDateErr">Please enter valid To date</span>
            <!-- <img src="assets/images/calendar.svg" class="iLife-form-group_custom" (click)="d1.toggle()" /> -->
          </div>
          <div class="pl-4 pt-3">
            <button class="view" (click)="navigateToReportsWithFilter($event,0)">
              View
            </button>
          </div>
        </div>
      </div>
      <div class=" mb-5">
        <label class="padding-left-employees booking-history pt-4">Meeting Room Usage</label>
        <div class="d-flex row col-12 pt-3 padding-left-employees">
          <div class="form-group capitaland-form-group mr-4">
            <label for="owner-dob" class="form-label  from">From</label>
            <input class="form-control form-control-lg cal-icon cal-style cal-text" (click)="d4.toggle()"
              autocomplete="off" [readonly]="true" (keypress)="$event.preventDefault()" id="owner-dob"
              placeholder="dd | mm | yyyy" type="text" name="dp" ngbDatepicker #d4="ngbDatepicker"
              [(ngModel)]="meetingFromDate">
            <span class="field-error" *ngIf="meetingFromDateErr">Please enter valid From date</span>
            <!-- <img src="assets/images/calendar.svg" class="iLife-form-group_custom " (click)="d.toggle()" /> -->
          </div>
          <div class="form-group capitaland-form-group" style="position:relative">
            <label for="owner-dob" class="form-label from">To</label>
            <input class="form-control form-control-lg cal-icon cal-style cal-text" (click)="d5.toggle()"
              autocomplete="off" [readonly]="true" (keypress)="$event.preventDefault()" id="owner-dob"
              placeholder="dd | mm | yyyy" type="text" name="dp" ngbDatepicker #d5="ngbDatepicker"
              [(ngModel)]="meetingToDate">
            <span class="field-error" *ngIf="meetingToDateErr">Please enter valid To date</span>
            <!-- <img src="assets/images/calendar.svg" class="iLife-form-group_custom" (click)="d1.toggle()" /> -->
          </div>
          <div class="pl-4 pt-3">
            <button class="view" (click)="navigateToReportsWithFilter($event, 3)">
              View
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- <app-footer></app-footer> -->
  </div>
</div>
